import { render, staticRenderFns } from "./contact_nav.vue?vue&type=template&id=724fae06&scoped=true&"
import script from "./contact_nav.vue?vue&type=script&setup=true&lang=ts&"
export * from "./contact_nav.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./contact_nav.vue?vue&type=style&index=0&id=724fae06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724fae06",
  null
  
)

export default component.exports